import Button from 'src/components/common/Button';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TelecomType } from 'src/types/type';

import sktOn from 'src/assets/images/icon_skt_on.png';
import sktOff from 'src/assets/images/icon_skt.png';
import ktOn from 'src/assets/images/icon_kt_on.png';
import ktOff from 'src/assets/images/icon_kt.png';
import lgOn from 'src/assets/images/icon_lg_on.png';
import lgOff from 'src/assets/images/icon_lg.png';
import { useRecoilState, useRecoilValue } from 'recoil';
import { TelecomTypeState } from 'src/recoil/join';
import { JoinStepState, PartnerState } from 'src/recoil/ui';

const TelecomWrap = styled.div`
  width: 100%;
  display: flex;
`;

const TelecomData: TelecomInfoType[] = [
  { telecomId: 0, type: 'skt', display: 'off' },
  { telecomId: 1, type: 'kt', display: 'off' },
  { telecomId: 2, type: 'lgu', display: 'off' },
];

interface TelecomInfoType {
  telecomId: TelecomType;
  type: string;
  display: string;
}

interface TelecomProps {
  onClick: () => void;
}

const Telecom = (props: TelecomProps) => {
  const { telecom, telecomActive } = useParams();
  const [telecomType, setIsTelecomType] = useRecoilState(TelecomTypeState);
  const [telecomItem, setTelecomItem] = useState<TelecomInfoType[]>(TelecomData);
  const joinStep = useRecoilValue(JoinStepState);
  const { UiData: { layoutsInsert: { agency: { actColor }}}} = useRecoilValue(PartnerState)
  useEffect(() => {
    !!telecomActive &&
      setTelecomItem(
        TelecomData.map((element, index) => {
          if (Number(telecomActive) === element.telecomId) {
            return { ...element, display: 'on' };
          } else {
            return { ...element, display: 'off' };
          }
        }),
      );

    !telecomActive &&
      setTelecomItem(
        TelecomData.map((element, index) => {
          return { ...element, display: 'on' };
        }),
      );
  }, [telecomActive]);

  useEffect(() => {
    !!Number(telecom) ? setIsTelecomType(Number(telecom)) : setIsTelecomType(0);
  }, [telecom, setIsTelecomType]);

  const handleButtonClick = (index: number) => {
    setIsTelecomType(index);
    props.onClick();
  };

  const handleTelecomImage = (type: string, index: number) => {
    switch (type) {
      case 'skt':
        return telecomType === index ? sktOn : sktOff;
      case 'kt':
        return telecomType === index ? ktOn : ktOff;
      case 'lgu':
        return telecomType === index ? lgOn : lgOff;
    }
  };

  const handleButtonStyles = (element: { type: string; display: string }, index: number) => {
    return {
      backgroundImage: handleTelecomImage(element.type, index),
      backgroundColor: telecomType === index ? '#fff' : '#e5e5e5',
      height: '60px',
      border: telecomType === index ? `2px solid ${actColor}` : '1px solid #bbbbbb',
      display: element.display === 'off' ? 'none' : 'block',
    };
  };

  return (
    <TelecomWrap>
      {telecomItem.map((element, index) => (
        <Button
          key={index}
          onClick={() => handleButtonClick(index)}
          styles={handleButtonStyles(element, index)}
          disabled={joinStep === 1}
        />
      ))}
    </TelecomWrap>
  );
};

export default Telecom;
